import React from "react";
import { Form } from "react-final-form";
import { useExitIntentSettingsModal } from "./utils/useExitIntentSettingsModal";
import { ExitIntentSettingsModal } from "./modules/ExitIntentSettingsModal/ExitIntentSettingsModal";
import { checkIsObjectEmpty } from "features/Common/modules/DataTypes/utils/object";

export const ExitIntentFormSettings = ({ initialValues, onSubmit }) => {
  const { exitIntentInitialValues, updateExitIntentsettings } =
    useExitIntentSettingsModal();

  const resolvedInitialValues = !checkIsObjectEmpty(exitIntentInitialValues)
    ? exitIntentInitialValues
    : initialValues;

  const resolvedOnSubmit = !checkIsObjectEmpty(updateExitIntentsettings)
    ? updateExitIntentsettings
    : onSubmit;

  return (
    <Form initialValues={resolvedInitialValues} onSubmit={resolvedOnSubmit}>
      {({ handleSubmit }) => (
        <form onSubmit={handleSubmit}>
          <ExitIntentSettingsModal handleSubmit={handleSubmit} />
        </form>
      )}
    </Form>
  );
};
